var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackendSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166.358,
    height: 130.22,
    viewBox: "0 0 166.358 130.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "backend_sm-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 166.358,
    height: 130.22,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_181",
    "data-name": "Groupe 181",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_180",
    "data-name": "Groupe 180",
    transform: "translate(0 0)",
    clipPath: "url(#backend_sm-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_246",
    "data-name": "Trac\\xE9 246",
    d: "M123.389,80.537c-7.153,9.113-14.9,17.734-24.04,24.908-9.526,7.479-20.238,11.561-32.609,9.69a55.773,55.773,0,0,1-23.528-9.226c-6.419-4.424-12.963-8.853-18.607-14.177-10.377-9.791-14.3-31-7.016-44.006C24.817,34.822,33,22.814,43.828,12.684,56.235,1.074,70.466-1.8,86.39,3.952c11.562,4.179,21.578,10.792,30.68,19.091,5.861,5.342,11.353,10.868,13.842,18.442C136,56.729,128.9,73.52,123.389,80.537",
    transform: "translate(15.347 1.193)",
    fill: "#d9e0ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_247",
    "data-name": "Trac\\xE9 247",
    d: "M75.368,25.258a26.376,26.376,0,0,1-4.525-4.413A7.55,7.55,0,0,1,69.1,14.883,10.19,10.19,0,0,1,70.812,10.6a28.371,28.371,0,0,1,2.607-3.385,7.348,7.348,0,0,1,8.04-1.237A25.71,25.71,0,0,1,87.832,10.8a7.09,7.09,0,0,1,1.553,7.779,16.735,16.735,0,0,1-3.513,5.583,8.187,8.187,0,0,1-3.38,2.51,8.373,8.373,0,0,1-7.123-1.412",
    transform: "translate(76.434 5.844)",
    fill: "#d9e0ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_248",
    "data-name": "Trac\\xE9 248",
    d: "M24.027,64.037c0-1.42-.017-2.839,0-4.257A3.974,3.974,0,0,1,27.8,55.843c1.467-.067,2.938-.053,4.407-.023a4.255,4.255,0,0,0,4.514-3.273,32.88,32.88,0,0,1,1.4-3.528,3.873,3.873,0,0,0-.824-4.48q-1.5-1.562-3.045-3.077a4.2,4.2,0,0,1-.131-6.008q2.81-2.883,5.7-5.688a4.1,4.1,0,0,1,6.048-.065c.9.822,1.739,1.7,2.584,2.573a4,4,0,0,0,4.59.965c1.654-.7,3.317-1.385,4.948-2.133a3.906,3.906,0,0,0,2.274-3.743c.046-1.442-.011-2.891.116-4.325a3.97,3.97,0,0,1,3.789-3.517q4.334-.066,8.666,0a3.97,3.97,0,0,1,3.895,3.892c.032,1.216.006,2.432.015,3.65a4.4,4.4,0,0,0,3.108,4.367,22.986,22.986,0,0,1,3.618,1.564,4.142,4.142,0,0,0,5.311-.875c.759-.78,1.524-1.555,2.31-2.31a4.133,4.133,0,0,1,6.213,0q2.823,2.757,5.587,5.574a4.152,4.152,0,0,1-.04,6.048c-1.016,1.024-2.036,2.046-3.041,3.081a3.87,3.87,0,0,0-.883,4.407c.558,1.439,1.123,2.875,1.675,4.316a4.084,4.084,0,0,0,4.017,2.567c1.4.023,2.788-.006,4.181.011a4.05,4.05,0,0,1,4.268,4.314c.006,2.662.011,5.321,0,7.981a4.047,4.047,0,0,1-4.16,4.2c-1.519.023-3.041,0-4.561.011a4.055,4.055,0,0,0-4.169,2.993c-.39,1.071-.856,2.112-1.313,3.155A4.151,4.151,0,0,0,99.892,83.7q1.6,1.565,3.151,3.184a4.085,4.085,0,0,1,.057,5.591q-3.088,3.2-6.3,6.27a4.127,4.127,0,0,1-5.65-.369c-.858-.824-1.684-1.684-2.5-2.544-1.127-1.18-2.367-2.082-4.129-1.791a2.319,2.319,0,0,0-.521.091c-1.7.721-3.42,1.4-5.087,2.2a3.984,3.984,0,0,0-2.152,3.755c-.067,1.416-.006,2.837-.017,4.255a4.072,4.072,0,0,1-4.3,4.3c-2.535.013-5.068.008-7.6,0a4.229,4.229,0,0,1-4.567-4.47c-.027-1.165-.011-2.331-.006-3.5.011-2.885-.792-3.989-3.517-4.961a27.569,27.569,0,0,1-2.794-1.187,3.952,3.952,0,0,0-4.936.754c-.984.95-1.922,1.945-2.891,2.908A4.2,4.2,0,0,1,40.615,99a10.875,10.875,0,0,1-1.576-1.418c-1.606-1.581-3.2-3.176-4.8-4.763a4.284,4.284,0,0,1-.013-6.131q1.634-1.641,3.269-3.283a3.952,3.952,0,0,0,.929-4.413c-.527-1.477-1.136-2.927-1.783-4.354a3.929,3.929,0,0,0-3.871-2.312c-1.494-.019-2.988,0-4.485-.008a4.062,4.062,0,0,1-4.259-4.251c-.008-1.342,0-2.685,0-4.027Zm69.063-2.3c-.356-6.377-5.2-10.588-10.021-14.763C77.026,41.749,67.94,38.1,60.21,40.305c-5.062,1.446-25.928,21.871-8.691,43.165,4.727,5.84,15.155,4.339,22.518,2.478,5.079-1.283,12.78-3.791,15.867-7.983,3.2-4.346,3.444-10.8,3.186-16.223",
    transform: "translate(26.602 21.58)",
    fill: "#99c600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_249",
    "data-name": "Trac\\xE9 249",
    d: "M51.276,61.072c-6.434-.008-11.692-7.7-11.661-14.255A11.758,11.758,0,0,1,51.288,35c6.453.006,14.43,4.881,14.394,11.443-.036,6.535-8,14.634-14.407,14.626",
    transform: "translate(43.872 38.764)",
    fill: "#384c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_250",
    "data-name": "Trac\\xE9 250",
    d: "M92.092,26.886C89.7,13.222,77.651-2.142,63.985.248L15,4.9C1.334,7.3-1.644,23.148.748,36.815A25.121,25.121,0,0,0,29.823,57.232l34.274-6a73.263,73.263,0,0,0,13.532,8.2,1,1,0,0,0,1.119-1.623A17.261,17.261,0,0,1,74.861,53a16.446,16.446,0,0,1-1.34-3.439c13.176-2.784,20.91-9.3,18.571-22.678",
    transform: "translate(0 0)",
    fill: "#4d6837"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_251",
    "data-name": "Trac\\xE9 251",
    d: "M24.016,25.418l-9.3-6.137.333,2.126,6.969-8.691c1.3-1.621-1.41-3.376-2.71-1.753l-6.967,8.691a1.434,1.434,0,0,0,.333,2.126l9.3,6.137c1.741,1.144,3.777-1.355,2.042-2.5",
    transform: "translate(13.303 11.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_252",
    "data-name": "Trac\\xE9 252",
    d: "M27.4,11.305l9.3,6.137-.335-2.126L29.4,24.007c-1.3,1.621,1.41,3.376,2.71,1.753l6.967-8.691a1.434,1.434,0,0,0-.333-2.126l-9.3-6.137c-1.741-1.144-3.777,1.355-2.042,2.5",
    transform: "translate(29.613 9.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_253",
    "data-name": "Trac\\xE9 253",
    d: "M23,34.812,30.627,8.835c.554-1.895-2.58-2.972-3.14-1.062L19.86,33.749c-.554,1.892,2.58,2.972,3.14,1.062",
    transform: "translate(21.922 7.497)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackendSm);
export default __webpack_public_path__ + "static/media/backend_sm.64c9d9e73a005cc436bc326142215c92.svg";
export { ForwardRef as ReactComponent };